export enum EventRSVPConfirmationPageType {
  YES = 'YES',
  NO = 'NO',
  MAYBE = 'MAYBE',
  WAITLIST = 'WAITLIST',
  PENDING = 'PENDING_APPROVAL',
}
